import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { BookmarkProcessState } from '@doda/common/src/hooks/useSaveBookmark';
import { RootState } from 'redux/store';

interface BookmarkSliceState {
  bookmarkState: BookmarkProcessState;
}

export const bookmarkInitialState: BookmarkSliceState = {
  bookmarkState: 'default',
};

/** 複数コンポーネントから気になる状態にアクセスするためのステート */
const bookmarkSlice = createSlice({
  name: 'bookmark',
  initialState: bookmarkInitialState,
  reducers: {
    setBookmarkState: (_, action: PayloadAction<BookmarkProcessState>) => {
      return { bookmarkState: action.payload };
    },
  },
});

export const { setBookmarkState } = bookmarkSlice.actions;

export const bookmarkReducer = bookmarkSlice.reducer;

/**
 * bookmarkStateを取得するSelector
 * @param state
 */
export const bookmarkStateSelector = (state: RootState): BookmarkProcessState =>
  state.bookmark.bookmarkState;
